/* eslint import/no-extraneous-dependencies: 0 */
import Nataraja from './nataraja';
export { Nataraja };
